export default __webpack_public_path__ + "static/media/loading.5b290281.png";